import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@auth0/auth0-angular';
import { WorklistComponent } from './worklist/worklist.component';
import { IncidentsComponent } from './incidents/incidents.component';
import { InstrumentCategoriesComponent } from './instrument-categories/instrument-categories.component';
import { SensorsComponent } from './sensors/sensors.component';
import { GureDashboardComponent } from './gure-dashboard/gure-dashboard.component';
import { OpsDashboardComponent } from './ops-dashboard/ops-dashboard.component';
import { IncidentDetailComponent } from './incident-detail/incident-detail.component';
import { InstrumentListComponent } from './instrument-list/instrument-list.component';
import { InstrumentServiceComponent } from './instrument-service/instrument-service.component';
import { InstrudexUserGuard } from '../guards/instrudex-user.guard';
import { WorklistListComponent } from './worklist-list/worklist-list.component';

const routes: Routes = [
  { path: '', redirectTo: 'incidents', pathMatch: 'full' },
  { path: 'ops-dashboard', component: OpsDashboardComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'gure-dashboard', component: GureDashboardComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  //{ path: 'go-fmx', component: GoFmxDetailComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  //{ path: 'go-fmx-request', component: GoFmxRequestComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'incidents', component: IncidentsComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'incident-detail', component: IncidentDetailComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'instrument-categories', component: InstrumentCategoriesComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'instrument-list', component: InstrumentListComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'instrument-service', component: InstrumentServiceComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'sensors', component: SensorsComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'worklist-list', component: WorklistListComponent, canActivate: [AuthGuard, InstrudexUserGuard] },
  { path: 'worklist', component: WorklistComponent, canActivate: [AuthGuard, InstrudexUserGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OpsAppRoutingModule { }
